import { useRef, useState } from "react";
import "./AdminSettings.css";

export default function AdminSettings() {
  const fileRef = useRef(null);

  // Demo state (use your real data/store later)
  const [form, setForm] = useState({
    firstName: "Admin",
    lastName: "User",
    email: "admin@legacy72.com",
  });

  const [pushEnabled, setPushEnabled] = useState(true);
  const [dndEnabled, setDndEnabled] = useState(false);
  const [theme, setTheme] = useState("light"); // 'light' | 'dark'
  const [password] = useState("".padStart(16, "•"));

  const onPickFile = () => fileRef.current?.click();

  return (
    <div className="asettings-container">
      <button className="welcome">← Back Admin Dashboard</button>
      <h1 className="username">Admin Settings</h1>

      {/* Personal Info */}
      <section className="asettings-card">
        <div className="asettings-card-head">Personal Information</div>

        <div className="asettings-content">
          <div className="asettings-form">
            <div className="asettings-row-2">
              <div className="asettings-field">
                <label>First Name</label>
                <input
                  value={form.firstName}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, firstName: e.target.value }))
                  }
                  className="asettings-input"
                  placeholder="First name"
                />
              </div>
              <div className="asettings-field">
                <label>Last Name</label>
                <input
                  value={form.lastName}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, lastName: e.target.value }))
                  }
                  className="asettings-input"
                  placeholder="Last name"
                />
              </div>
            </div>

            <div className="asettings-field">
              <label>Email Address</label>
              <input value={form.email} disabled className="asettings-input" />
            </div>

            <div className="asettings-field asettings-password-field">
              <label>Password</label>
              <div className="asettings-password-wrapper">
                <input value={password} readOnly className="asettings-input" />
                <button
                  type="button"
                  className="asettings-btn-change"
                  onClick={() => alert("Open change password modal")}
                >
                  Change
                </button>
              </div>
            </div>
          </div>

          {/* Avatar */}
          <div className="asettings-avatar-section">
            <div className="asettings-avatar">
              <img
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=600&auto=format&fit=crop"
                alt="Admin avatar"
              />
            </div>
            <button className="asettings-btn-change-avatar" onClick={onPickFile}>
              Change
            </button>
            <input
              ref={fileRef}
              type="file"
              accept="image/*"
              onChange={() => alert("Handle upload")}
              hidden
            />
          </div>
        </div>
      </section>

      {/* System Settings */}
      <section className="asettings-card">
        <div className="asettings-card-head">System Settings</div>

        <div className="asettings-row between">
          <div className="asettings-setting-block">
            <div className="asettings-setting-title">Notification Settings</div>
          </div>
          <div className="asettings-setting-controls">
            <label className="asettings-check">
              <input
                type="checkbox"
                checked={pushEnabled}
                onChange={(e) => setPushEnabled(e.target.checked)}
              />
              <span>Push notifications</span>
            </label>
            <label className="asettings-check">
              <input
                type="checkbox"
                checked={dndEnabled}
                onChange={(e) => setDndEnabled(e.target.checked)}
              />
              <span>Do not disturb schedule</span>
            </label>
          </div>
        </div>

        <div className="asettings-divider" />

        <div className="asettings-row between">
          <div className="asettings-setting-block">
            <div className="asettings-setting-title">Display Preferences</div>
          </div>
          <div className="asettings-setting-controls">
            <label className="asettings-radio">
              <input
                type="radio"
                name="theme"
                value="dark"
                checked={theme === "dark"}
                onChange={(e) => setTheme(e.target.value)}
              />
              <span>Dark mode</span>
            </label>
            <label className="asettings-radio">
              <input
                type="radio"
                name="theme"
                value="light"
                checked={theme === "light"}
                onChange={(e) => setTheme(e.target.value)}
              />
              <span>Light mode</span>
            </label>
          </div>
        </div>
      </section>
    </div>
  );
}
